import React, { useState } from 'react';
import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useSelector } from 'react-redux';
import Selector from '../Selector';
import List from '../List';
import Recipe from '../Recipe';
import vector from '../../assets/chef.png';
import './styles.sass';

const useStyles = makeStyles({
    text: {
        '&&': {
            fontFamily: `'Rubik', sasn-serif`,
            wordWrap: "break-word",
            textAlign: 'center'
        }
    }
});

const Recipes = ({ showRecipe, setShowRecipe }) => {
    const [selectedCategory, setSelectedCategory] = useState('');
    const recipes = useSelector(state => state.recipes);
    const filtered = recipes.filter((recipe) => recipe.category.includes(selectedCategory));
    const classes = useStyles();

    return !showRecipe ? (
        <div className="recipes-container">
            {recipes.length > 0 ?
                <>
                    <Selector
                        categories={[...new Set(recipes.map(recipe => recipe.category))]}
                        selectedCategory={selectedCategory}
                        setSelectedCategory={setSelectedCategory}
                        origin='כל המתכונים'
                    />
                    <List
                        recipes={filtered}
                        setShowRecipe={setShowRecipe}
                    />
                </>
                :
                <div className="no-recipes-container">
                    <img src={vector} alt="Vector" className="image" />
                    <Typography display="inline" variant='h5' className={classes.text}>ברוכים הבאים ל-CookEat! לפני שנתחיל במלאכת הבישול,<br /> יש להתחיל להוסיף מתכונים.</Typography>
                </div>
            }
        </div>
    ) : (
        <Recipe setShowRecipe={setShowRecipe} />
    )
}

export default Recipes;